var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66667H2.22222V4.44444H0V6.66667ZM0 11.1111H2.22222V8.88889H0V11.1111ZM0 2.22222H2.22222V0H0V2.22222ZM4.44444 6.66667H20V4.44444H4.44444V6.66667ZM4.44444 11.1111H20V8.88889H4.44444V11.1111ZM4.44444 0V2.22222H20V0H4.44444ZM0 6.66667H2.22222V4.44444H0V6.66667ZM0 11.1111H2.22222V8.88889H0V11.1111ZM0 2.22222H2.22222V0H0V2.22222ZM4.44444 6.66667H20V4.44444H4.44444V6.66667ZM4.44444 11.1111H20V8.88889H4.44444V11.1111ZM4.44444 0V2.22222H20V0H4.44444Z",
    fill: "#44494D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter2);
export default __webpack_public_path__ + "static/media/IconFilter2.78508d2b.svg";
export { ForwardRef as ReactComponent };